// HELGA Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
    });
  }

  // Close mobile nav on outside click
  document.addEventListener('click', function (e) {
    if (mobileNav && mobileNav.classList.contains('open')) {
      if (!mobileNav.contains(e.target) && !menuBtn.contains(e.target)) {
        mobileNav.classList.remove('open');
      }
    }
  });

  // Sticky header shadow on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.borderBottomColor = 'var(--sand-dark)';
      } else {
        header.style.borderBottomColor = 'var(--sand)';
      }
    }, { passive: true });
  }

  // Ingredient card subtle hover animation
  const ingCards = document.querySelectorAll('.ing-card');
  ingCards.forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      card.querySelector('.ing-icon') && (card.querySelector('.ing-icon').style.borderColor = 'var(--turmeric)');
    });
    card.addEventListener('mouseleave', function () {
      card.querySelector('.ing-icon') && (card.querySelector('.ing-icon').style.borderColor = 'var(--sand)');
    });
  });

});
